// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-action-drag {
  position: absolute;
  left: 10px;
  top: 5px;
  right: 25px;
  height: 6px;
  cursor: grab;
}
*:hover > .n-action-drag {
  border-top: 2px dotted color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
  border-bottom: 2px dotted color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/actions/DragAction/DragAction.less"],"names":[],"mappings":"AAAA,mDAAmD;AAGnD;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AADF;AAGE;EACE,0FAAA;EACA,6FAAA;AADJ","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n\n.n-action-drag {\n  position: absolute;\n  left: 10px;\n  top: 5px;\n  right: 25px;\n  height: 6px;\n  cursor: grab;\n\n  *:hover > & {\n    border-top: 2px dotted @TableAction-hover-color;\n    border-bottom: 2px dotted @TableAction-hover-color;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
